export default __webpack_public_path__ + "static/media/launch.39f40b65.webp";